import { toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _toDisplayString(_ctx.value ? _ctx.$t('common.yes') : _ctx.$t('common.no'))
}